<template>
  <div class="container">
    <div class="is-clearfix mb-3">
      <v-step-progress
        :steps="steps"
        passive-color="rgba(var(--rgb-text-grey-color), .6)"
        active-color="var(--bids)"
        :passive-thickness="2"
        :active-thickness="2"
        :line-thickness="2"
        :current-step="step - 1"
        icon-class="sr sr-check"
      ></v-step-progress>
    </div>
    <b-overlay
      :show="loading"
      rounded
      opacity="0.6"
      spinner
      spinner-variant="primary"
      class="registration-steps-container"
      @hidden="!loading"
    >
      <transition name="fade">
        <personal-information-form
          v-if="step === 2"
          @next="step++"
          :email="email"
          :csrf="csrf"
          :statusofaddress="statusofaddress"
          :banks="banks"
          :start-small-step="startSmallStep"
          @previous="step--"
          key="2"
        >
        </personal-information-form>
        <!-- <pay-card v-if="step === 3"
                   @previous="step--"
                   @next="step++"
                   key="3">
          </pay-card> -->
      </transition>
    </b-overlay>
  </div>
</template>

<script>
import StepProgress from 'vue-step-progress'
import PayCard from './Registration/PayCard.vue'
import PersonalInformationForm from './Registration/PersonalInformationForm'
import 'vue-step-progress/dist/main.css'
import {mapState} from "vuex";

export default {
  components: {
    PersonalInformationForm,
    'v-step-progress': StepProgress,
    PayCard,
  },
  props: {
    startStep: {
      required: false,
      default: 2,
    },
    employmentstatus: {
      type: Object,
    },
    activity: {
      type: Array,
    },
    statusofaddress: {
      type: Object,
    },
    trading_amount: {
      type: Object,
    },
    salary: {
      type: Object,
    },
    other_income: {
      type: Object,
    },
    banks: {
      type: Object,
    },
    email: {
      type: String,
    },
    csrf: {
      type: String,
    },
    danUserInfo: {
      type: Object,
      required: false,
      default: null
    }
  },
  data() {
    return {
      steps: [
        `${this.$t('registration.email-authorization')}`,
        `${this.$t('registration.personal-info')}`,
        `${this.$t('registration.payment-info')}`,
      ],
      step: 2,
      loading: false,
      startSmallStep: 1
    }
  },
  computed: {
    ...mapState('user', ['danState', 'tempUser']),
  },
  created() {
    this.step = this.startStep
    if(this.danUserInfo) {
      this.startSmallStep = 2
      this.$store.dispatch('user/setDanResult', this.danUserInfo)
    }
    // window.onbeforeunload = function () {
    //   return "Талбарууд дээрх таны бөглөсөн мэдээлэл устахыг анхаарна уу."
    // }
  },
}
</script>

<style lang="scss" scoped>
.registration-steps {
  &-container {
    margin-top: 5rem;
  }
}
</style>
